var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      model: {
        value: _vm.dialogModel.visible,
        callback: function($$v) {
          _vm.$set(_vm.dialogModel, "visible", $$v)
        },
        expression: "dialogModel.visible"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v(_vm._s(_vm.dialogModel.headline))
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-flex", { attrs: { "text-xs-center": "" } }, [
                _vm._v("\n        " + _vm._s(_vm.dialogModel.text) + "\n      ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _vm.dialogModel.hasCancelBtn
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", test: "" },
                      on: { click: _vm.cancel }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.dialogModel.cancelText
                            ? _vm.dialogModel.cancelText
                            : "Cancel"
                        )
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", flat: "" },
                  on: { click: _vm.ok }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.dialogModel.okText ? _vm.dialogModel.okText : "Ok"
                    )
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }